import type { GuidanceStepConfig } from "../../models/guidance/GuidanceTypes";

export const WORK_GUIDANCE_TOTAL_STEPS = 29;

export const WORK_GUIDANCE_STEPS: GuidanceStepConfig[] = [
  {
    step: 1,
    textKey: "guidance.welcomeDescription",
    advanceMode: "welcome",
  },
  {
    step: 2,
    targetSelector: '[data-tooltip="submodule-function-settings"]',
    textKey: "guidance.step1Text",
    tooltipPosition: "right",
    advanceMode: "click",
    allowedSidebarItems: ["function-settings"],
    navigateOnClick: "/app/eplex/function-settings",
  },
  {
    step: 3,
    targetSelector: ".eplex-function-settings .dx-datagrid-filter-row",
    textKey: "guidance.step2Text",
    tooltipPosition: "bottom",
    route: "/app/eplex/function-settings",
    advanceMode: "button",
    allowedSidebarItems: ["function-settings"],
  },
  {
    step: 4,
    targetSelector: ".eplex-function-settings__table-wrapper",
    textKey: "guidance.step3Text",
    tooltipPosition: "right",
    route: "/app/eplex/function-settings",
    advanceMode: "button",
    videoUrl: "/videos/guidance/step3-configure-supplier.mp4",
    allowedSidebarItems: ["function-settings"],
  },
  {
    step: 5,
    targetSelector: ".eplex-function-settings__table-wrapper",
    textKey: "guidance.step3PanelText",
    tooltipPosition: "right",
    route: "/app/eplex/function-settings",
    advanceMode: "panel",
    warnCondition: "hasConfiguredSuppliers",
    allowedSidebarItems: ["function-settings"],
  },
  {
    step: 6,
    targetSelector: '[data-tooltip="submodule-single-search"]',
    textKey: "guidance.step4Text",
    tooltipPosition: "right",
    route: "/app/eplex/function-settings",
    advanceMode: "click",
    allowedSidebarItems: ["function-settings", "single-search"],
    navigateOnClick: "/app/eplex/single-search",
  },
  {
    step: 7,
    targetSelector: ".single-search__choosing-plugins",
    textKey: "guidance.step5Text",
    tooltipPosition: "right",
    route: "/app/eplex/single-search",
    advanceMode: "button",
    allowedSidebarItems: ["function-settings", "single-search"],
    ensureFreshTab: true,
  },
  {
    step: 8,
    targetSelector: ".single-search__input",
    titleKey: "guidance.step6Title",
    textKey: "guidance.step6Text",
    hintKey: "guidance.step6Hint",
    tooltipPosition: "bottom",
    route: "/app/eplex/single-search",
    advanceMode: "button",
    imageUrl: "/icons/guidance/search-article-example.webp",
    allowedSidebarItems: ["function-settings", "single-search"],
  },
  {
    step: 9,
    targetSelector: ".single-search__input",
    titleKey: "guidance.step7Title",
    textKey: "guidance.step7Text",
    hintKey: "guidance.step7Hint",
    tooltipPosition: "bottom",
    route: "/app/eplex/single-search",
    advanceMode: "button",
    imageUrl: "/icons/guidance/search-vin-example.webp",
    allowedSidebarItems: ["function-settings", "single-search"],
  },
  {
    step: 10,
    targetSelector: ".eplex-ws-corner",
    textKey: "guidance.stepTabGroupingText",
    tooltipPosition: "bottom",
    route: "/app/eplex/single-search",
    advanceMode: "button",
    videoUrl: "/videos/guidance/step10-tab-grouping.mp4",
    allowedSidebarItems: ["function-settings", "single-search"],
    tooltipMaxWidth: 800,
  },
  {
    step: 11,
    targetSelector: ".single-search",
    textKey: "guidance.step8PanelText",
    tooltipPosition: "bottom",
    route: "/app/eplex/single-search",
    advanceMode: "panel",
    allowedSidebarItems: ["function-settings", "single-search"],
  },
  {
    step: 12,
    targetSelector: '[data-tooltip="submodule-markup-settings"]',
    textKey: "guidance.step9Text",
    tooltipPosition: "right",
    route: "/app/eplex/single-search",
    advanceMode: "click",
    allowedSidebarItems: ["function-settings", "single-search", "markup-settings"],
    navigateOnClick: "/app/eplex/markup-settings",
  },
  {
    step: 13,
    targetSelector: ".eplex-markup-settings__section",
    textKey: "guidance.step10Text",
    tooltipPosition: "right",
    route: "/app/eplex/markup-settings",
    advanceMode: "button",
    videoUrl: "/videos/guidance/step9-markup-settings.mp4",
    allowedSidebarItems: ["function-settings", "single-search", "markup-settings"],
  },
  {
    step: 14,
    targetSelector: ".eplex-markup-settings__section",
    textKey: "guidance.step11PanelText",
    tooltipPosition: "right",
    route: "/app/eplex/markup-settings",
    advanceMode: "panel",
    warnCondition: "hasCreatedMarkup",
    allowedSidebarItems: ["function-settings", "single-search", "markup-settings"],
  },
  {
    step: 15,
    targetSelector: '[data-tooltip="submodule-single-search"]',
    textKey: "guidance.step12Text",
    tooltipPosition: "right",
    route: "/app/eplex/markup-settings",
    advanceMode: "click",
    allowedSidebarItems: ["function-settings", "single-search", "markup-settings"],
    navigateOnClick: "/app/eplex/single-search",
  },
  {
    step: 16,
    // На телефоне селектор типов цен остаётся в разметке, но раскрывается в
    // `display: contents` — своей рамки у него нет, подсветке нечего мерить, и
    // шаг оставался пустым, а обучение дальше не шло (CAB-489, замечание 17).
    // Там типы цен вызывают из меню «⋮» верхней полосы — его и показываем.
    targetSelector: [".price-type-selector", "#mobile-topbar-actions .mobile-action-menu__trigger"],
    textKey: "guidance.step13Text",
    mobileTextKey: "guidance.step13TextMobile",
    tooltipPosition: "left",
    route: "/app/eplex/single-search",
    advanceMode: "button",
    allowedSidebarItems: ["function-settings", "single-search", "markup-settings"],
  },
  {
    step: 17,
    targetSelector: ".eplex-filters__section",
    textKey: "guidance.step14Text",
    tooltipPosition: "right",
    route: "/app/eplex/single-search",
    advanceMode: "button",
    allowedSidebarItems: ["function-settings", "single-search", "markup-settings"],
  },
  {
    step: 18,
    // самый родительский контейнер левой панели — есть всегда (и без запущенной проценки),
    // тогда как блок кнопок фильтров появляется только после результатов
    targetSelector: ".single-search__choosing-plugins",
    textKey: "guidance.step15Text",
    tooltipPosition: "right",
    route: "/app/eplex/single-search",
    advanceMode: "button",
    videoUrl: "/videos/guidance/step13-save-filter.mp4",
    allowedSidebarItems: ["function-settings", "single-search", "markup-settings"],
  },
  {
    step: 19,
    targetSelector: ".single-search__grouping-toggle-button",
    textKey: "guidance.step16Text",
    tooltipPosition: "bottom",
    route: "/app/eplex/single-search",
    advanceMode: "button",
    videoUrl: "/videos/guidance/step14-grouping.mp4",
    tooltipMaxWidth: 800,
    allowedSidebarItems: ["function-settings", "single-search", "markup-settings"],
  },
  {
    step: 20,
    targetSelector: ".single-search__result-search",
    textKey: "guidance.step17Text",
    tooltipPosition: "left",
    route: "/app/eplex/single-search",
    advanceMode: "button",
    videoUrl: "/videos/guidance/step15-add-to-cart.mp4",
    allowedSidebarItems: ["function-settings", "single-search", "markup-settings"],
  },
  {
    step: 21,
    targetSelector: ".single-search__history-button",
    textKey: "guidance.step18Text",
    tooltipPosition: "bottom",
    route: "/app/eplex/single-search",
    advanceMode: "button",
    allowedSidebarItems: ["function-settings", "single-search", "markup-settings"],
  },
  {
    step: 22,
    targetSelector: '[data-tooltip="submodule-journal"]',
    textKey: "guidance.step19Text",
    tooltipPosition: "right",
    route: "/app/eplex/single-search",
    advanceMode: "click",
    allowedSidebarItems: ["function-settings", "single-search", "markup-settings", "journal"],
    navigateOnClick: "/app/eplex/journal",
  },
  {
    step: 23,
    targetSelector: ".journal-quick-filters",
    textKey: "guidance.step20Text",
    tooltipPosition: "bottom",
    route: "/app/eplex/journal",
    advanceMode: "button",
    allowedSidebarItems: ["function-settings", "single-search", "markup-settings", "journal"],
  },
  {
    step: 24,
    // Кнопка «Оформить», а не вся группа действий: на телефоне группа —
    // раскладочная обёртка без собственной геометрии (display: contents),
    // и подсветка по ней схлопывалась в точку. Шаг и так про эту кнопку.
    targetSelector: '[data-tool="make-order"]',
    textKey: "guidance.step21Text",
    tooltipPosition: "bottom",
    route: "/app/eplex/journal",
    advanceMode: "button",
    videoUrl: "/videos/guidance/step19-make-order.mp4",
    allowedSidebarItems: ["function-settings", "single-search", "markup-settings", "journal"],
  },
  {
    step: 25,
    targetSelector: ".journal-table__data-grid",
    textKey: "guidance.step22Text",
    tooltipPosition: "right",
    route: "/app/eplex/journal",
    advanceMode: "button",
    videoUrl: "/videos/guidance/step20-order-statuses.mp4",
    allowedSidebarItems: ["function-settings", "single-search", "markup-settings", "journal"],
  },
  {
    step: 26,
    targetSelector: ".eplex-grouping-toggle-icon",
    textKey: "guidance.stepJournalGroupingText",
    tooltipPosition: "bottom",
    route: "/app/eplex/journal",
    advanceMode: "button",
    videoUrl: "/videos/guidance/step26-journal-grouping.mp4",
    tooltipMaxWidth: 900,
    allowedSidebarItems: ["function-settings", "single-search", "markup-settings", "journal"],
  },
  {
    step: 27,
    targetSelector: '[data-tooltip="submodule-guidance"]',
    textKey: "guidance.step23Text",
    tooltipPosition: "right",
    advanceMode: "button",
    allowedSidebarItems: ["function-settings", "single-search", "markup-settings", "journal", "guidance"],
  },
  {
    step: 28,
    // Класс, а не data-tooltip: тот атрибут проставляется только у свёрнутого
    // бокового меню и служит подсказке DevExtreme. На телефоне меню всегда
    // развёрнуто, цели не находилось вовсе — шаг показывал пустое затемнение.
    targetSelector: ".sidebar-footer__button--support",
    textKey: "guidance.step24Text",
    tooltipPosition: "right",
    advanceMode: "button",
    allowedSidebarItems: ["function-settings", "single-search", "markup-settings", "journal", "guidance"],
  },
  {
    step: 29,
    textKey: "guidance.finishDescription",
    advanceMode: "finish",
  },
];

export const ONBOARDING_GUIDANCE_TOTAL_STEPS = 7;

/** Шаг «Первая проценка» онбординга — на нём показываются кнопки-примеры поиска. */
export const GUIDANCE_STEP_FIRST_SEARCH = 2;

/** Шаг «Оформление заказа» онбординга — тур продвигается по факту успешного заказа. */
export const GUIDANCE_STEP_MAKE_ORDER = 6;

/** Шаг «Сохранить поставщика» онбординга — карточка поставщика должна закрыться при уходе с него. */
export const GUIDANCE_STEP_SAVE_SUPPLIER = 4;

// 7 шагов вместо прежних 9 (ТЕСТ ОНБОРДИНГ §0): шаги-рассказы (было 4 и 7)
// убраны, их текст перенесён внутрь соседних интерактивных шагов — те, в свою
// очередь, получили второе визуальное состояние на месте рассказа
// (secondaryTargetSelector/secondaryTextKey, см. store/guidance.ts).
export const ONBOARDING_GUIDANCE_STEPS: GuidanceStepConfig[] = [
  {
    step: 1,
    textKey: "guidance.welcomeDescription",
    advanceMode: "welcome",
  },
  {
    step: 2,
    // Строка поиска, «Найти» и три кнопки-примера — ровно то, что перечислено
    // в задании (ТЕСТ ОНБОРДИНГ 2, шаг 2), окно тура у правого края. Каждая
    // кнопка-пример отдельным селектором, а не общий .single-search__example-buttons —
    // контейнер растягивается на всю ширину строки (это и подсвечивалось
    // «почти во весь экран», критичная правка).
    targetSelector: [".single-search__input", ".single-search__find-btn", ".single-search__example-buttons__button"],
    textKey: "guidance.tourFirstSearchText",
    tooltipPosition: "right",
    route: "/app/eplex/single-search",
    advanceMode: "interact",
    advanceCondition: "hasPerformedNewSearch",
    allowedSidebarItems: ["single-search"],
    // «Свободная зона» (readyToAdvance) — уже готовый результат проценки,
    // подсвечиваем всё окно проценки целиком (§3). Цель — почти весь экран,
    // поэтому «right» с вертикальным центрированием клало окно тура прямо
    // на середину таблицы результатов — перекрывало попап «кол-во товара» у
    // кнопки добавления в корзину. «bottom» прижимает окно к низу вьюпорта:
    // targetRect.bottom у такой большой цели всегда ниже экрана, поэтому
    // после клампа по границам вьюпорта окно уезжает к нижнему краю, а не в
    // середину таблицы.
    secondaryTargetSelector: ".single-search",
    secondaryTextKey: "guidance.tourFirstSearchResultText",
    secondaryTooltipPosition: "bottom",
    secondaryHintKey: "guidance.tourFirstSearchResultHint",
    secondaryHintIcon: "cart",
  },
  {
    step: 3,
    targetSelector: '[data-tooltip="submodule-function-settings"]',
    textKey: "guidance.tourSuppliersNavText",
    tooltipPosition: "right",
    route: "/app/eplex/single-search",
    advanceMode: "click",
    allowedSidebarItems: ["single-search", "function-settings"],
    navigateOnClick: "/app/eplex/function-settings",
  },
  {
    step: 4,
    // Кнопка «Настроить своего поставщика» убрана со страницы совсем (ТЕСТ
    // ОНБОРДИНГ 2, шаг 4) — подсвечиваем прямо в таблице: поле поиска по
    // названию и карандаш в каждой видимой строке (грид виртуальный, в DOM и
    // так только отрисованные строки — «по высоте видимых строк» само собой).
    // tooltipPosition считается от первого таргета (поле поиска в шапке
    // таблицы), «right» от него встаёт примерно над колонкой карандашей —
    // проверить на стенде, точной позиции «выше колонки» тип не поддерживает.
    targetSelector: [
      ".eplex-suppliers-grid__title-filter-cell .dx-texteditor-input",
      ".eplex-suppliers-grid__configure-btn",
    ],
    textKey: "guidance.tourSaveSupplierText",
    hintKey: "guidance.tourSuppliersListHint",
    tooltipPosition: "right",
    route: "/app/eplex/function-settings",
    advanceMode: "interact",
    advanceCondition: "hasAddedNewSupplier",
    allowedSidebarItems: ["single-search", "function-settings"],
    // Карточка поставщика открылась (secondaryHighlightActive от
    // EplexFunctionSettings.vue) — подсвечиваем правую колонку формы
    // («Авторизация и поиск») и кнопки «Проверить»/«Сохранить», а не весь
    // попап целиком (там же «Основные настройки» — не то, ради чего открыли
    // карточку). Прицельно вычленить именно поля логина/пароля нельзя: у
    // разных поставщиков свой набор dataField от API — но их всегда рендерит
    // DevExtreme Form как DxTabbedItem, а ему навешивает СВОЙ, не проектный
    // класс .dx-field-item-has-tabs на весь блок вкладки (m_form.js) — под
    // него попадает вся колонка целиком, сколько бы полей у поставщика ни
    // было. Кнопки — просто все .dx-button внутри .popup-footer. Ссылка
    // «Настройте за меня» (.popup-configure-for-me-link) добавлена отдельной
    // целью: подсказка прямо про неё говорит, а сама ссылка тонкая и
    // визуально терялась на фоне формы — без своей подсветки её не находили
    // (CAB-636, замечание 4).
    // Цель лежит ВНУТРИ попапа (z-index DevExtreme-пула ≥ 1500) — обычная
    // подсветка рендерится в контейнере с z-index 500 и совсем не видна из-за
    // попапа поверх неё («модалка не затемнена»); highlightInForeground
    // переносит именно подсветку в контейнер окна тура (см. GuidanceOverlay).
    // «right» от такой широкой цели (почти вся ширина попапа) после клампа по
    // вьюпорту ложилось обратно на попап, перекрывая поля логина/пароля —
    // «bottom» уводит окно тура под попап, где есть свободное место, но при
    // полностью развёрнутой карточке (окно поставщика в полную высоту) этого
    // свободного места под попапом уже не остаётся, и «bottom» клампится
    // прямо на кнопку «Проверить». «center-bottom» фиксирует окно тура по
    // центру снизу экрана, отдельно упираясь нижним краем в верх футера
    // попапа (см. centerBottomLimit в useGuidanceOverlay) — кнопки всегда
    // остаются доступны.
    secondaryTargetSelector: [".dx-field-item-has-tabs", ".popup-footer .dx-button", ".popup-configure-for-me-link"],
    secondaryTextKey: "guidance.tourSaveSupplierCardText",
    secondaryTooltipPosition: "center-bottom",
    secondaryHighlightInForeground: true,
  },
  {
    step: 5,
    targetSelector: '[data-tooltip="submodule-journal"]',
    textKey: "guidance.tourCartNavText",
    tooltipPosition: "right",
    route: "/app/eplex/function-settings",
    advanceMode: "click",
    allowedSidebarItems: ["single-search", "function-settings", "journal"],
    navigateOnClick: "/app/eplex/journal",
  },
  {
    step: 6,
    // Чекбокс в шапке таблицы — DevExtreme-класс, проверить на стенде (§6).
    targetSelector: ".journal-table__data-grid .dx-datagrid-headers .dx-select-checkbox",
    textKey: "guidance.tourCartCheckboxText",
    // Корзина пуста — чекбокса в шапке нет; объясняем, как сюда попадают позиции
    noTargetTextKey: "guidance.tourCartEmptyText",
    // «right», не «bottom»: чекбокс — самый левый край шапки таблицы, окно
    // строго под ним закрывало первые строки (ТЕСТ ОНБОРДИНГ 2) — проверить
    // на стенде, что окно не съезжает обратно на таблицу.
    tooltipPosition: "right",
    route: "/app/eplex/journal",
    advanceMode: "interact",
    allowedSidebarItems: ["single-search", "function-settings", "journal"],
    // Отмечена хотя бы одна строка (secondaryHighlightActive от
    // EplexJournal.vue) — подсвечиваем «Оформить»/«Удалить» и сводку выбора,
    // но НЕ соседние иконки обновления/демо-режима в том же контейнере (ТЕСТ
    // ОНБОРДИНГ 2, п.31 — раньше .journal-topbar__actions цепляла их тоже).
    // Если клиент снимет все чекбоксы, secondaryHighlightActive сама станет
    // false и подсветка вернётся к чекбоксу — доп. логики не нужно.
    secondaryTargetSelector: ['[data-tool="make-order"]', '[data-tool="delete"]', ".journal-topbar__selection-info"],
    secondaryTextKey: "guidance.tourMakeOrderText",
    secondaryTooltipPosition: "right",
  },
  {
    step: 7,
    textKey: "guidance.finishDescription",
    advanceMode: "finish",
  },
];
